// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1612514682097
      var cssReload = require("/Users/tudyzhb/pure/src/git.yichui.net/yichui1/uni-contrib/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  